const createChart = (data, elementId, mode) => {
  const colors = ["#A2ABAF", "#b50043", "#fc9200"];

  let dataProvider = [];
  for (let i = 0; i < 4; i++) {
    dataProvider = dataProvider.concat({
      period: `Q${i + 1}`,
      ...data.map((year, key) => chooseValue(year[i + 1], mode))
    });
  }

  const config = {
    type: "serial",
    categoryField: "period",
    dataProvider,
    valueAxes: [
      {
        axisAlpha: 0,
        position: "left",
        title: mode.header
      }
    ],
    startDuration: 1,
    graphs: Object.keys(data).map((year, key) => ({
      fillColors: colors[key],
      fillAlphas: 0.9,
      lineAlpha: 0.2,
      title: year,
      type: "column",
      valueField: year
    })),
    legend: {
      horizontalGap: 10,
      useGraphSettings: true,
      markerSize: 10
    }
  };


  AmCharts.makeChart(elementId, config);
};

// Choose value from multiple available sources: "default", "ifrs16" etc.
function chooseValue(quarter, mode) {

  const defaultValueId = 'default';

  if (!quarter[defaultValueId]) {
    return 0;
  }

  return parseFloat(quarter[defaultValueId][mode.field][0].value)
}

export default createChart;
